// extracted by extract-css-chunks-webpack-plugin
module.exports = {"license-agreement":"license-agreement","center":"center","heading":"heading"};